export default {
  getParam: function(param) {
    const urlParams = new URLSearchParams(location.search);
    if (urlParams.has(param)) {
      return urlParams.get(param);
    }
    return null;
  },
  hasParam: function(param) {
    const urlParams = new URLSearchParams(location.search);
    return urlParams.has(param);
  },
  setParam: function(param, val) {
    let urlParams = new URLSearchParams(location.search);
    urlParams.set(param, val);
    return urlParams;
  },
  setParams: function (obj) {
    let urlParams = new URLSearchParams(location.search);
    for (const [key, value] of Object.entries(obj)) {
      urlParams.set(key, value);
    }
    return urlParams;
  }
};
